import Box from "@mui/material/Box";
import React from "react";
import { TextView } from "@components";
import { ASSETS } from "../../../utils/config";
import Wheels from "./Wheels";
import { colors } from "../../../utils";
import { Stack } from "@mui/material";


const styles = {
  tabHeader: {
    borderBottom: 1,
    borderColor: "divider",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
  },
  tabStack: (selectedTab, tabName) => ({
    width: `${100 / 3}%`, 
    cursor: "pointer",
    borderBottom: selectedTab === tabName ? "1px solid #123051" : "none",
  }),
  tabIcon: (selectedTab, tabName) => ({
    height: "14px",
    width: "16px",
    marginRight: "3px",
    opacity: selectedTab !== tabName ? 0.5 : 1,
  }),
  tabText: (selectedTab, tabName, colors) => ({
    color: selectedTab !== tabName ? colors.lightGrey : colors.primary,
  }),
  boxContainer: {
    my: 2,
  },
};

function TabView({ tabs = [], onTabChange = () => {} , selectedTab }) {
  

  const handleTabChange = (tabName) => {
    // setSelectedTab(tabName);
    onTabChange(tabName);
  };

  return (
    <Box sx={styles.boxContainer}>
      <Box sx={styles.tabHeader}>
        {tabs.map(({ name, icon }) => (
          <Stack
          direction={"row"}
          justifyContent={"center"}
          alignItems={"center"}
            key={name}
            sx={styles.tabStack(selectedTab, name)}
            onClick={() => handleTabChange(name)}
          >
            {icon && (
              <img
                src={icon}
                alt={name}
                style={styles.tabIcon(selectedTab, name)}
              />
            )}
            <Box sx={styles.tabText(selectedTab, name, colors)}>
              {name}
            </Box>
          </Stack>
        ))}
      </Box>
      {/* {tabs.map(({ name, content }) => (
        selectedTab === name && (
          <Box key={name}>
            {typeof content === 'function' ? content() : content}
          </Box>
        )
      ))} */}
    </Box>
  );
}

export default TabView;
